import { useTexts } from '../../../../contexts/TextsContext';
import { useData } from '../../../../contexts/DataContext';
import { resolveAssetUrl } from '../../../../utils/utils';
import classes from './footer.module.scss';

const Footer = () => {
    const texts = useTexts();
    const { footerSocial } = useData();

    return (
        <footer className={classes.Footer}>
            <div className={classes.Inner}>
                <div className={classes.Contact}>
                    <p className={classes.ContactHeading}>{texts.contactHeading}</p>
                    <a href={`mailto:${texts.email}`} className={classes.ContactRow}>
                        <img src={resolveAssetUrl('/assets/icons/icon-email.png')} alt="" aria-hidden="true" className={classes.ContactIcon} />
                        <span>{texts.email}</span>
                    </a>
                    <a href={`tel:${texts.phone?.replace(/-/g, '') ?? ''}`} className={classes.ContactRow}>
                        <img src={resolveAssetUrl('/assets/icons/icon-phone.png')} alt="" aria-hidden="true" className={classes.ContactIcon} />
                        <span>{texts.phone}</span>
                    </a>
                    <p className={classes.ContactRow}>
                        <img src={resolveAssetUrl('/assets/icons/icon-location.svg')} alt="" aria-hidden="true" className={classes.ContactIcon} />
                        <span>{texts.address}</span>
                    </p>
                </div>

                <nav className={classes.Social} aria-label={texts.socialNavLabel}>
                    {footerSocial.map((social) => (
                        <a key={social.id} href={social.href} target="_blank" rel="noreferrer" aria-label={texts[`${social.id}Label`]} className={classes.SocialLink} >
                            <img src={resolveAssetUrl(social.iconSrc)} alt="" aria-hidden="true" className={classes.SocialIcon} />
                        </a>
                    ))}
                </nav>
            </div>

            <div className={classes.FooterBottom}>
                {texts.footerSlogan && <p className={classes.Slogan}>{texts.footerSlogan}</p>}
                <p className={classes.Copyright}>{texts.copyright}</p>
            </div>
        </footer>
    );
};

export default Footer;
